export class BannerWowGo {
  id: number;
  descricao: string;
  url: string;
  ativo: boolean;
  nomeArquivo: string;
  contentType: string;
  documentType: string;
  dataFileBase64: string;
  dataInicio: string;
  dataTermino: string;

  constructor(
    id: number,
    descricao: string,
    url: string,
    ativo: boolean,
    nomeArquivo: string,
    contentType: string,
    documentType: string,
    dataFileBase64: string,
    dataInicio: string,
    dataTermino: string
  ) {
    this.id = id;
    this.descricao = descricao;
    this.url = url;
    this.ativo = ativo;
    this.nomeArquivo = nomeArquivo;
    this.contentType = contentType;
    this.documentType = documentType;
    this.dataFileBase64 = dataFileBase64;
    this.dataInicio = dataInicio;
    this.dataTermino = dataTermino;
  }
}
